import { Component, OnInit } from '@angular/core';
import {ActivatedRoute,Router, Routes, RouterModule} from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {AfterViewInit,ElementRef} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxSmartModalService } from 'ngx-smart-modal';
import * as confetti from 'canvas-confetti';
import { interval } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Title }     from '@angular/platform-browser';
@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit, AfterViewInit {
  uuid: string;
  isHeadStart = environment.isHeadStart;
  videoScript: any;
  player: any;
  siteID = environment.siteID;
  loaded:boolean = false;
  constructor(private titleService: Title, public ngxSmartModalService: NgxSmartModalService, private spinner: NgxSpinnerService, private route:ActivatedRoute, public http: HttpClient, private router: Router){this.checkRefresh();}
  video: any = [];
  channel: any = [];
  menuShow: boolean = false;
  myPlayer:any;
  playlists: any = [];
  isWoohoo: boolean = environment['isWooHoo'];
  title: any = [];
  celebrate: boolean = false;
  celebrationMessages: any = [];
  notifications: any = [];
  confettiGunReady: boolean = true;
  confettiGunLoaded: boolean = true;
  contents: any = [];
  channelID='';
  playlistID='1';
  Isfavourite = false;
  totalEntries: any = [];
  IswatchLater = false; 
  refresh = '';
  channelName: any;
  public instantCelebration() {
    this.celebrationMessages = [];
    this.confettiGunReady = true;
  this.confettiGunLoaded = true;
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  this.http.get('https://api-staging.videyo.tv/endpoint/getNotifications?siteID='+this.siteID,{
    headers:myheader
  })
  .subscribe(
    data => {
      this.notifications = data['notification'];
      this.celebrationMessages =  this.notifications.filter(function(message) {
        return message.type == "CELEBRATION";
      });
      this.celebrationMessages =  this.notifications.filter(function(message) {
        return message.notificationNoted == false;
      });
      
console.log('celebration message')
console.log(this.celebrationMessages);
    },
    error => {
    });
    this.notifications = [];
  }
  public checkCelebrations() {
    this.instantCelebration(); 
    interval(20000).subscribe(x => {
      this.celebrationMessages = [];
      this.confettiGunReady = true;
    this.confettiGunLoaded = true;
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
    this.http.get('https://api-staging.videyo.tv/endpoint/getNotifications?siteID='+this.siteID,{
      headers:myheader
    })
    .subscribe(
      data => {
        this.notifications = data['notification'];
        this.celebrationMessages =  this.notifications.filter(function(message) {
          return message.type == "CELEBRATION";
        });
        this.celebrationMessages =  this.notifications.filter(function(message) {
          return message.notificationNoted == false;
        });
        
  console.log('celebration message')
  console.log(this.celebrationMessages);
      },
      error => {
      });
      this.notifications = [];
  });
  }
  refreshNow(): void {
    window.location.reload();
}
  public checkRefresh() { 
    this.route.params.subscribe(params2 => {
      this.refresh = params2['rf'];
      setTimeout(() => {
        /** spinner ends after 5 seconds */
        this.loaded = false;
      }, 1000);
      setTimeout(() => {
        /** spinner ends after 5 seconds */
        this.loaded = true;
      }, 2000);
      if (this.refresh == 'rf') {
        this.ping();
      }
      else {
        location.href = this.router.url+'/rf';
      }
  });
}

  public ping() {
    this.route.params.subscribe(params2 => {
      this.uuid = params2['uuid'];
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data').set('responseType', 'text');
      let body = new HttpParams();
      this.http.get('https://api-staging.videyo.tv/endpoint/getContentDetails?uuid='+this.uuid, {
        headers: myheader
      })
      .subscribe(
        
        data => {
          this.video = data;
          this.channelID = this.video.channelID;
          this.playlistID = this.video.playlistID;
          this.channelName = this.video.name;
          this.titleService.setTitle( this.video['title']);
          this.Isfavourite = this.video.isFavourite;
          this.IswatchLater = this.video.isWatchLater;
          this.suggest();
          
        });
        },
        error => {
        }
      );
    }
    showMenu() { 
      this.menuShow = !this.menuShow;
    }
    
// public getWoohooEntries() { 
//  this.http.get('https://staging.videyo.tv/endpoint/getCurrentEntries?siteID='+this.siteID, {
//   })
//   .subscribe(
//     data => {
//       console.log('entries');
//       console.log(data);
//       this.totalEntries = data['totalEntriesToday'];
//     },
//     error => {
//     }
//   );
  
// }

public suggest() {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data').set('responseType', 'text');
    this.http.get('https://api-staging.videyo.tv/endpoint/getChannel?siteID='+this.siteID+'&depth=3&channelID='+this.channelID, {
      headers: myheader
    })
    .subscribe(
      data => {
        this.channel = data;
        this.playlists = data['playlists'];
        this.contents = [];// reset to empty list.
        this.playlists.forEach(playlist => { // add playlist to this.playlist.
               // then, for each playlist, let’s get a hold of each item of
               // content and add it to the total list of content...
               playlist.contents.forEach( content => {
                 this.contents.push(content); // add it to the array.
                
               }
              );
           });
      },
      error => {
      }
    );
}
  ngAfterViewInit()
  {
    this.route.params.subscribe( params2 =>{
      this.uuid= params2['uuid'];
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data').set('responseType', 'text');
      let body = new HttpParams();                                 // /stream/renderContentView?uuid=“+uuid+“&targetDiv=“+targetDiv
      // http://videyo-tmp.eu-west-2.elasticbeanstalk.com
      // http://localhost:8080
      this.http.get('https://api-staging.videyo.tv/stream/renderContentView?uuid='+this.uuid+'&targetDiv=videoholder&openFullScreen=true',{
      headers:myheader,
      responseType:'text'
      })
    .subscribe(
      res => {
         this.videoScript = res;
         var scriptHolder = document.createElement('script');
         scriptHolder.innerHTML = res;
         // var s=document.createElement("script");
         // //s.type="text/javascript";
         // s.innerHTML=res; //inline script
         document.body.appendChild(scriptHolder);
         setTimeout(() => { 
          this.addScript();
      })
      },
      error => {
      }
    );
    });
    

  }
  public addScript () {
      var scriptHolderQuality = document.createElement('script');
         scriptHolderQuality.innerHTML = "console.log('Test');";
         document.body.appendChild(scriptHolderQuality); 
  }
  
  public favourite(contentId, playlistId) {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
    
    this.http.get('https://api-staging.videyo.tv/endpoint/makeFavorite?siteID='+this.siteID+'&playlistID='+playlistId+'&contentId='+contentId+'&channelID='+this.channelID,{
      headers:myheader
    })
    .subscribe(
      data => {
        this.Isfavourite = !this.Isfavourite;
      },
      error => {
      }
  );
  }
  public unfavourite(contentId, playlistId) {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
    
    this.http.get('https://api-staging.videyo.tv/endpoint/makeUnFavorite?siteID='+this.siteID+'&channelID='+this.channelID+'&playlistID='+playlistId+'&contentId='+contentId,{
      headers:myheader
    })
    .subscribe(
      data => {
        this.Isfavourite = !this.Isfavourite;
      },
      error => {
      }
  );
  }
  public myList(contentId, playlistId){
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  
  this.http.get('https://api-staging.videyo.tv/endpoint/addToMyList?siteID='+this.siteID+'&channelID='+this.channelID+'&playlistID='+playlistId+'&contentId='+contentId,{
    headers:myheader
  })
  .subscribe(
    data => {
    },
    error => {
    }
);
  }
  public watchLater(contentId, playlistId){
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  
  this.http.get('https://api-staging.videyo.tv/endpoint/addToWatchLater?siteID='+this.siteID+'&channelID='+this.channelID+'&playlistID='+playlistId+'&contentId='+contentId,{
    headers:myheader
  })
  .subscribe(
    data => { 
   this.IswatchLater = !this.IswatchLater;
    },
    error => {  
    }
);
  }
  public unwatchLater(contentId, playlistId){
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
  
  this.http.get('https://api-staging.videyo.tv/endpoint/removeFromWatchLater?siteID='+this.siteID+'&channelID='+this.channelID+'&playlistID='+playlistId+'&contentId='+contentId,{
    headers:myheader
  })
  .subscribe(
    data => {
      this.IswatchLater = !this.IswatchLater;
    },
    error => {
    }
);
  }
  ngOnInit() {
    /** spinner starts on init */
    this.spinner.show();
  
  }
  public confettiGun() {
    this.confettiGunLoaded = false;
    var myCanvas = document.getElementById('CustomCanvas');
    var myConfetti = confetti.create(myCanvas, { resize: true });
    var end = Date.now() + (15 * 200);
    if (Date.now() > end) {
      this.celebrate = true;
    }
    else { 
      this.celebrate = false;
    }
    function r(min, max) {
      return Math.random() * (max - min) + min;
  }
  
  myConfetti({
      angle: r(55, 125),
      spread: r(50, 70),
      particleCount: r(50, 100),
      origin: {
          y: 0.6
      }
  });
  
  setTimeout(() => {
    this.endConfettiGun() 
  }, 3000);
    setTimeout(() => {
      document.getElementById('CustomCanvas').appendChild(myCanvas);
    }, 1000);
   
  }
  endConfettiGun() {
  this.clearNotifications(); this.confettiGunReady = false; this.confettiGunLoaded = false;
  }
  
    
  public clearNotification(idTemp) {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
    this.http.get('https://api-staging.videyo.tv/endpoint/viewNotification?siteID='+this.siteID+'&notificationID='+idTemp,{
    })
    .subscribe(
      data => {
      },
      error => {
      });
  }
  public clearNotifications() {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
    this.http.get('https://api-staging.videyo.tv/endpoint/clearNotifications?siteID='+this.siteID,{
    })
    .subscribe(
      data => {
      },
      error => {
      }
  );
  }
}